import { ErrorPage } from '@resurs-internal/deposits-app-components';
import { useContext } from 'react';

import { CountryContext } from '@/contexts';

export type ErrorViewProps = {
  code: '404' | '500' | 'denied';
};

export const ErrorView = ({ code }: ErrorViewProps) => {
  const { country } = useContext(CountryContext);

  return <ErrorPage code={code} country={country} />;
};
